// Shared between AgentRepoProductOwner.vue (the /admin/agent-repos card) and
// ProductOwnerReviewRepoTable.vue (#1631) — a friendly phrase beats a raw
// minute count. Mirrors ProductOwnerRunJob's own display convention
// (config/recurring.agent.yml comments).
export function pollIntervalLabel(minutes: number): string {
  if (minutes === 1440) return '1 day'
  return minutes % 60 === 0 ? `${minutes / 60} hour${minutes === 60 ? '' : 's'}` : `${minutes} minutes`
}
